import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface MetricBadgeProps {
  label: string;
  value: string;
  trend?: number;
  status?: 'success' | 'warning' | 'error' | 'default';
}

const statusStyles = {
  success: 'text-green-600 bg-green-50 border-green-200',
  warning: 'text-yellow-600 bg-yellow-50 border-yellow-200',
  error: 'text-red-600 bg-red-50 border-red-200',
  default: 'text-gray-600 bg-gray-50 border-gray-200'
};

export function MetricBadge({ label, value, trend, status = 'default' }: MetricBadgeProps) {
  const getTrendIcon = () => {
    if (trend === undefined) return null;
    if (trend > 0) return <TrendingUp className="w-3 h-3 text-green-500" />;
    if (trend < 0) return <TrendingDown className="w-3 h-3 text-red-500" />;
    return <Minus className="w-3 h-3 text-gray-400" />;
  };

  const getTrendText = () => {
    if (trend === undefined) return '';
    return trend > 0 ? `+${trend}%` : `${trend}%`;
  };

  return (
    <div className="flex items-center gap-2">
      <div className="text-xs">
        <div className="text-muted-foreground">{label}</div>
        <div className="font-mono font-medium">{value}</div>
      </div>
      {trend !== undefined && (
        <div className="flex items-center gap-1">
          {getTrendIcon()}
          <span className={cn(
            'text-xs font-medium',
            trend > 0 ? 'text-green-600' : trend < 0 ? 'text-red-600' : 'text-gray-400'
          )}>
            {getTrendText()}
          </span>
        </div>
      )}
    </div>
  );
}